'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.inside = inside;
exports.encodePolyline = encodePolyline;
exports.decodePolyline = decodePolyline;
exports.fromSVY21 = fromSVY21;
exports.toSVY21 = toSVY21;
exports.toLinearRing = toLinearRing;
exports.disjointBbox = disjointBbox;

var _polyline = require('@mapbox/polyline');

var _polyline2 = _interopRequireDefault(_polyline);

var _proj = require('proj4');

var _proj2 = _interopRequireDefault(_proj);

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PRECISION = 7;

var SVY21 = '+proj=tmerc +lat_0=1.366666666666667 +lon_0=103.8333333333333 +k=1 +x_0=28001.642 +y_0=38744.572 +ellps=WGS84 +units=m +no_defs';
var SVY21proj = (0, _proj2.default)('WGS84', SVY21);

/* eslint-disable camelcase */
function inside(_ref, polyline) {
  var _ref2 = (0, _slicedToArray3.default)(_ref, 2);

  var lng = _ref2[0];
  var lat = _ref2[1];

  var isInside = false;
  for (var i = 1; i < polyline.length; i++) {
    var deltaY_plus = polyline[i][1] - lat;
    var deltaY_minus = lat - polyline[i - 1][1];
    if (deltaY_plus > 0 && deltaY_minus <= 0) continue;
    if (deltaY_plus < 0 && deltaY_minus >= 0) continue;
    var deltaX = (deltaY_plus * polyline[i - 1][0] + deltaY_minus * polyline[i][0]) / (deltaY_plus + deltaY_minus) - lng;
    if (deltaX <= 0) continue;
    isInside = !isInside;
  }
  return isInside;
}
/* eslint-enable camelcase */

function encodePolyline(arr) {
  return _polyline2.default.encode(arr, PRECISION);
}

function decodePolyline(str) {
  return _polyline2.default.decode(str, PRECISION).map(function (_ref3) {
    var _ref4 = (0, _slicedToArray3.default)(_ref3, 2);

    var lng = _ref4[0];
    var lat = _ref4[1];
    return [Math.round(lng * Math.pow(10, PRECISION - 2)) / Math.pow(10, PRECISION - 2), Math.round(lat * Math.pow(10, PRECISION - 2)) / Math.pow(10, PRECISION - 2)];
  });
}

function fromSVY21(xy) {
  return SVY21proj.inverse(xy);
}

function toSVY21(lnglat) {
  return SVY21proj.forward(lnglat);
}

function toLinearRing(polyline) {
  var linearRing = typeof polyline === 'string' ? decodePolyline(polyline) : (0, _cloneDeep2.default)(polyline);
  var firstPoint = linearRing[0];
  var lastPoint = linearRing[linearRing.length - 1];
  if (firstPoint[0] !== lastPoint[0] || firstPoint[1] !== lastPoint[1]) {
    linearRing.push(firstPoint);
  }
  return linearRing;
}

function disjointBbox(a, b) {
  if (a[0] < b[0] && a[2] < b[0]) return true;
  if (a[0] > b[2] && a[2] > b[2]) return true;
  if (a[1] < b[1] && a[3] < b[1]) return true;
  if (a[1] > b[3] && a[3] > b[3]) return true;
  return false;
}


//////////////////
// WEBPACK FOOTER
// ./~/sg-heatmap/dist/helpers/geometry.js
// module id = 200
// module chunks = 0